import { createLoggerFactory } from '@css/lutrahub-kit';

export const createLogger = createLoggerFactory('otterapp-assets');
